import React from "react"
import {useGetAndFetchToken} from "../../hooks/useGetAndFetchToken";
import Loader from "../../components/loader/Loader";

interface PermissionProviderProps {
    children?: React.ReactNode
}

const AuthorizationProvider: React.FC<PermissionProviderProps> = ({children}) => {
    const {loading} = useGetAndFetchToken()
    if (loading) return <Loader/>

    return (
        <>
            {children}
        </>
    )
}

export default AuthorizationProvider
